const KEY = "dh_broker_profiles";

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function emptyBrokerProfile(session = {}) {
  return {
    broker_name: session.name || "",
    broker_title: "Broker of record",
    broker_email: session.email || "",
    broker_phone: "",
    license: "",
    license_expires: "",
    brokerage_license: "",
    association: "",
    office_name: session.office_name || "",
    office_phone: "",
    office_email: "",
    website: "",
    office_address: "",
    office_city: "",
    office_state: "CA",
    office_zip: "",
    locations: "",
    extra: "",
    password_hint: "",
    photo: "",
    office_logo: "",
    display_format: "name-title",
    agents_may_edit_office: false,
    pending_invites: [],
    compliance_notices: "",
    updated_at: null,
  };
}

export function getBrokerProfile(userId, session) {
  if (!userId) return emptyBrokerProfile(session);
  return { ...emptyBrokerProfile(session), ...(readAll()[userId] || {}) };
}

export function saveBrokerProfile(userId, profile) {
  if (!userId) return profile;
  const all = readAll();
  const next = { ...profile, updated_at: new Date().toISOString() };
  all[userId] = next;
  writeAll(all);
  return next;
}
